import { Box, styled } from '@mui/material';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  padding: '2px 3px',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 360,
  boxSizing: 'border-box',
  border: `1px solid ${theme.palette.grey[100]}`,
  background: theme.palette.grey[50],
}));
